import React, { useState } from "react";
import { Form, Input, Button, notification, Icon } from "antd";
import { Redirect, useLocation, useParams } from "react-router-dom";
import axios from "axios";

import Header from "../../../User/Header";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

const RecuperarPassword = ({ form, match }) => {
    const [confirmDirty, setConfirmDirty] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const location = useLocation();

    const { entidade } = useParams();

    const compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== form.getFieldValue("novaPassword")) {
            callback("Senhas não coincidentes");
        } else {
            callback();
        }
    };

    const validateToNextPassword = (rule, value, callback) => {
        if (value && confirmDirty) {
            form.validateFields(["confirmarPassword"], { force: true });
        }
        callback();
    };

    const handleConfirmBlur = e => {
        const { value } = e.target;

        setConfirmDirty(confirmDirty || !!value);
    };

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                handleChangePassword(values);
            }
        });
    };

    const handleChangePassword = registo => {
        setIsLoading(true);

        const params = new URLSearchParams(location.search);
        const userId = params.get("userId");
        const code = params.get("code");

        axios({
            method: "put",
            url: "/api/autenticacaonew/alterar-senha",
            params: {
                userId,
                code,
                new_password: registo.novaPassword
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Senha alterada!");
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível alterar a senha!");
            })
            .finally(() => {
                setRedirectLink(`/${entidade}/login-escola`);
                setRedirect(true);
                setIsLoading(false);
            });
    };

    const { getFieldDecorator } = form;

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Alterar Senha" />
            <Form className="login template-form" onSubmit={handleSubmit}>
                <div className="recuperar-password">
                    <Form.Item>
                        {getFieldDecorator("novaPassword", {
                            rules: [
                                {
                                    required: true,
                                    message: "Campo obrigatório"
                                },
                                {
                                    pattern: "^(?=.*[A-Z])(?=.*[0-9])(?=.{6,})",
                                    message: (
                                        <p>A senha deve conter pelo menos uma letra maiúscula, um número e um mínimo de 6 caracteres</p>
                                    )
                                },
                                {
                                    validator: validateToNextPassword
                                }
                            ]
                        })(<Input.Password type="password" placeholder="Nova senha" onBlur={handleConfirmBlur} />)}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator("confirmarPassword", {
                            rules: [
                                {
                                    required: true,
                                    message: "Campo obrigatório"
                                },
                                {
                                    validator: compareToFirstPassword
                                }
                            ]
                        })(<Input.Password type="password" placeholder="Confirmar senha" />)}
                    </Form.Item>
                </div>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button form-button" disabled={isLoading}>
                        {isLoading ? <Icon type="loading" /> : null}
                        Alterar
                    </Button>
                </Form.Item>
            </Form>
            <div style={{ height: 100 }}></div>
        </>
    );
};

const FormRecuperarPassword = Form.create({ name: "recuperar-password" })(RecuperarPassword);

export default FormRecuperarPassword;
